import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container, } from "react-bootstrap";
import { addHall } from "./Hall.action";
import { setHeading } from "../../../accounts/account.actions";
import { connect } from "react-redux";
import { isEmpty } from "lodash";
import { GlobalSpinner, showSuccessAlert, showErrorAlert } from "../../../../../global/globalFunctions";
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';


const AddHall = (props) => {
  const [hall, setHall] = useState("");
  const [hallDesc, setHallDesc] = useState("");


  function uploadHall() {
    props.addHall({
      hallName: hall,
      hallDesc: hallDesc,
    },
      showSuccessAlert,
      showErrorAlert,
    );
    setHallDesc("");
    setHall("");
  }

  useEffect(() => {
    props.setHeading("Add Hall");
  }, []);

  return (
    <>
      {props.isAddingHall ? (
        <GlobalSpinner />
      ) : (
        <Container fluid>
          <Form>
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label> <b>Department / Hall *</b></Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Department / Hall"
                    onChange={(e) => setHall(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label> <b>Description </b></Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Description"
                    onChange={(e) => setHallDesc(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>

            <div className="sendDiv">
              {isEmpty(hall) ? (
                <Button variant="contained" endIcon={<SendIcon />} size="large" disabled>SAVE</Button>
              ) : (
                <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={uploadHall}>SAVE</Button>
              )}
            </div>

          </Form>
        </Container>
      )}
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    addHall: (data, showSuccessAlert, showErrorAlert) => dispatch(addHall(data, showSuccessAlert, showErrorAlert)),
    setHeading: (data) => dispatch(setHeading(data)),
  };
};
const mapStateToProps = (state, ownProps) => ({
  isAddingHall: state.hallReducer.isAddingHall,
});

export default connect(mapStateToProps, mapDispatchToProps)(AddHall);
